import { styled } from '@mui/material/styles';
import { RadioButtonsGroup } from '@components/RadioButtonsGroup';

export { SplitModal as Modal, PreviewWrapper } from '@components/SplitModal';

export const FormWrapper = styled('div')({
    padding: '24px 16px',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    overflowX: 'hidden',
    '@media (max-width: 768px)': {
        overflowY: 'initial',
        overflowX: 'initial',
    },
});

export const Content = styled('div')({
    display: 'grid',
    gridGap: '8px',
    gridTemplateColumns: '100%',
});

export const RadioButtonsWrapper = styled('div')({
    height: 32,
    marginBottom: 16,
    width: 'fit-content',
});

export const RadioButtons = styled(RadioButtonsGroup)({
    display: 'block',
    '& .MuiFormControlLabel-root': {
        height: 32,
        padding: '0 12px',
        flexBasis: 'auto',
    },
});
